/*
  ===========================================================================
  // REUSABLE STAGGERED ANIMATION SCRIPT
  ===========================================================================
*/
(function() {
  // --- Configuration ---
  // This breakpoint should match your CSS
  const MOBILE_BREAKPOINT = 990; 
  const WRAPPER_SELECTOR = '.stagger-animation-wrapper'; // Parent container
  const ITEM_SELECTOR = '.stagger-animation-item';       // The items to animate
  const OFFSCREEN_CLASS = 'stagger-animation-item--offscreen'; // Hidden state class
  const CASCADE_ATTR = 'data-stagger-cascade';         // Attribute for stagger
  // ---------------------

  function initializeSectionAnimation(sectionElement) {
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

    // Find all items *inside this specific section wrapper*
    const allItems = Array.from(sectionElement.querySelectorAll(ITEM_SELECTOR));
    if (allItems.length === 0) return;

    if (isMobile) {
      // --- 📱 MOBILE LOGIC ---
      // Observe the PARENT wrapper. Animate all items at once.
      const mobileObserver = new IntersectionObserver((entries, observer) => {
        if (entries[0].isIntersecting) {
          allItems.forEach(item => {
            item.classList.remove(OFFSCREEN_CLASS);
            item.setAttribute('style', '--animation-order: 0;'); 
          });
          observer.unobserve(sectionElement);
        }
      }, { rootMargin: '0px 0px -50px 0px' });
      mobileObserver.observe(sectionElement);

    } else {
      // --- 💻 DESKTOP LOGIC ---
      // Observe each item individually for the staggered effect.
      function onDesktopIntersection(entries, observer) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const elementTarget = entry.target;
            elementTarget.classList.remove(OFFSCREEN_CLASS);

            if (elementTarget.hasAttribute(CASCADE_ATTR)) {
              // Find the 'true' index of this item in its group
              const trueIndex = allItems.indexOf(elementTarget);
              if (trueIndex > -1) {
                elementTarget.setAttribute('style', `--animation-order: ${trueIndex};`);
              }
            }
            observer.unobserve(elementTarget);
          }
        });
      }

      const desktopObserver = new IntersectionObserver(onDesktopIntersection, {
        rootMargin: '0px 0px -50px 0px',
      });

      allItems.forEach(item => desktopObserver.observe(item));
    }
  }

  // --- Main Execution ---
  function runAllAnimations() {
    // Find ALL wrappers on the page
    const allWrappers = document.querySelectorAll(WRAPPER_SELECTOR);
    // Loop through each one and initialize it
    allWrappers.forEach(wrapper => {
      initializeSectionAnimation(wrapper);
    });
  }

  // Run on initial page load
  window.addEventListener('DOMContentLoaded', runAllAnimations);

  // Re-run for Shopify Theme Editor (section load)
  document.addEventListener('shopify:section:load', function(event) {
    // Check if the loaded section *or* one of its children is a wrapper
    let wrapper = event.target.matches(WRAPPER_SELECTOR) 
                  ? event.target 
                  : event.target.querySelector(WRAPPER_SELECTOR);
    if (wrapper) {
      initializeSectionAnimation(wrapper);
    }
  });

})();